<template>
  <v-sheet class="py- my-1" height="100%">
    <v-row no-gutters>
      <v-col cols="4">
        <CommonStepper
            :title="$t('material_registration')"
            :height="componentHeight - 70"
            :store-name="storeStepperName"
            dto-action-command="MaterialDeliveryActionCommandDTO"
            :data="processData"
        >
          <template v-slot:item.1="{item}">
            <v-sheet
                class="px-3 py-3"
            >
              <BaseFieldString
                  v-model="processData.delivery_number"
                  :label="$t('delivery_number')"
                  class="mt-3"
                  :prepend-icon="manualIcon"
              ></BaseFieldString>
              <CommonPartialSelectFromTable
                  v-model="processData.provider_uid"
                  dto-list-query="ProviderListQueryDTO"
                  :store-name="storeSelectProviderName"
                  :sort-by="['name']"
                  :label="$t('provider')"
                  item-text="name"
                  class="mt-3"
                  :prepend-icon="manualIcon"
              >
              </CommonPartialSelectFromTable>
              <v-row dense no-gutters>
                <v-col cols="3">
                  <v-btn
                      @click="processData.material_owner_uid = '02bfd456-f984-4d2d-9fde-7f750edc126a'"
                  >
                    {{ $t('set_ke') }}
                  </v-btn>
                </v-col>
                <v-col cols="9">
                  <CommonPartialSelectFromTable
                      v-model="processData.material_owner_uid"
                      dto-list-query="MaterialOwnerListQueryDTO"
                      store-name="SelectMaterialOwner"
                      :sort-by="['name']"
                      :label="$t('material_owner')"
                      item-text="name"
                  >
                  </CommonPartialSelectFromTable>
                </v-col>
              </v-row>
              <v-row dense no-gutters>
                <v-col cols="12">
                  <CommonPartialSelectFromTable
                      v-model="processData.usage_restriction_uid"
                      dto-list-query="MaterialOwnerListQueryDTO"
                      store-name="SelectUsageRestriction"
                      :sort-by="['name']"
                      :label="$t('usage_restriction')"
                      item-text="name"
                  >
                  </CommonPartialSelectFromTable>
                </v-col>
              </v-row>
              <v-checkbox
                  v-model="processData.mandatory_pn"
                  :label="$t('mandatory_pn')"
                  class="mt-3">
              </v-checkbox>
              <v-btn
                  @click="onCreateMaterialDelivery()"
                  :disabled="!!!processData.provider_uid"
              >{{ $t('create_material_delivery') }}
              </v-btn>
            </v-sheet>
          </template>
          <template v-slot:item.2="{item}">
            <v-card>
              <MaterialDeliveryCardList
                  :height="400"
                  @select="onMaterialDeliverySelect($event)"
                  :selected-material-delivery="selectedMaterialDelivery"
                  store-name="MaterialDeliveryCardListStepper"
              ></MaterialDeliveryCardList>
              <v-card-actions>
                <v-btn
                    :disabled="!processData.material_delivery_uid"
                    @click="storeStepper.currentStep = STEP_VERIFICATION_SCAN; focusToVerificationCode()">
                  {{ $t('next_step') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
          <template v-slot:item.3="{item}">
            <v-card class="pt-1">
              <CommonFieldString
                  ref="field_verification_code"
                  v-model="processData.verification_code"
                  :enter-input="onVerificationCode"
                  :label="$t('verification_code')"
                  outlined
                  :clearable="true"
                  class="mt-1"
                  :prepend-icon="scanIcon"
                  :color="item.error ? 'red': null"
                  @input="processData.created_part_number=null; create_part_number=false; processData.confirmation_mpn_creation=false"
              ></CommonFieldString>
              <CommonFieldString
                  v-if="create_part_number && processData.mandatory_pn === true"
                  ref="field_created_part_number"
                  v-model="processData.created_part_number"
                  :enter-input="onVerificationCode"
                  :label="$t('create_part_number')"
                  outlined
                  :clearable="true"
                  class="mt-1"
                  :prepend-icon="manualIcon"
              ></CommonFieldString>
              <v-checkbox
                  ref="field_confirmation_mpn_creation"
                  v-if="create_part_number && processData.mandatory_pn === false"
                  v-model="processData.confirmation_mpn_creation"
                  :label="$t('confirmation_mpn_creation')"
              ></v-checkbox>
              <CommonPartialSelectFromTable
                  v-if="!create_part_number"
                  ref="field_manufacture_mpn"
                  v-model="manual_component_uid"
                  dto-list-query="ComponentShortListQueryDTO"
                  store-name="SelectMaterialComponent"
                  :sort-by="['article_display', 'alias']"
                  :label="$t('manual_mpn')"
                  item-text="alias_article"
                  class="mt-3"
                  :prepend-icon="manualIcon"
                  @input="onVerificationCode()"
              >
              </CommonPartialSelectFromTable>
              <v-select
                  v-model="processData.provider_name"
                  :items="providerNameList"
                  outlined
                  label="Provider name"
                  dense
                  clearable
              ></v-select>
              <v-card-actions>
                <v-btn
                    :disabled="!processData.verification_code ||
                    (create_part_number && !(processData.created_part_number || processData.confirmation_mpn_creation))"
                    @click="onVerificationCode()"
                >{{ $t('next_step') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
          <template v-slot:item.4="{item}">
            <v-card class="pt-1">
              <CommonFieldString
                  ref="field_customer_part_number_scan"
                  v-model="processData.part_number_code"
                  :enter-input="onPartNumber"
                  outlined
                  :clearable="true"
                  :label="$t('part_number_code')"
                  :prepend-icon="scanIcon"
                  :color="item.error ? 'red': null"
              ></CommonFieldString>
              <CommonSelectFromTable
                  ref="field_customer_part_number"
                  v-model="manual_part_number_uid"
                  dto-list-query="PartNumberListQueryDTO"
                  :store-name="storePartNumberTableName"
                  :sort-by="['part_number']"
                  :label="$t('manual_part_number')"
                  item-text="component_alias"
                  class="mt-3"
                  :prepend-icon="manualIcon"
                  @input="onPartNumber()"
                  :query-filters="{
                      and_concat: true,
                      filter_list: [
                        {param_compare: 'provider__uid', value: providerUid,},
                        {param_compare: 'deleted', value: false,},
                      ],
                      enable: true,
                    }"
              >
              </CommonSelectFromTable>
              <v-card-actions>
                <v-btn
                    @click="storeStepper.currentStep = STEP_VERIFICATION_SCAN; focusToVerificationCode()">
                  {{ $t('previous_step') }}
                </v-btn>
                <v-btn
                    :disabled="!processData.part_number_code && !processData.manual_part_number"
                    @click="onPartNumber()"
                >{{ $t('next_step') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
          <template v-slot:item.5="{item}">
            <v-card class="pt-3">
              <v-checkbox
                  v-model="processData.mass_registration"
                  :label="$t('mass_registration')"
                  readonly
              ></v-checkbox>
              <v-text-field
                  ref="field_amount_packages"
                  v-model.number="processData.amount_packages"
                  :label="$t('amount_packages')"
                  type="number"
                  @keyup.enter="focusToMaterialQty()"
                  @input="processData.mass_registration = processData.amount_packages > 1"
                  outlined
                  clearable
                  :prepend-icon="manualIcon"
              ></v-text-field>
              <CommonFieldString
                  ref="field_material_qty"
                  v-model.number="processData.material_qty"
                  type="number"
                  :enter-input="onMaterialQty"
                  :label="$t('material_qty')"
                  outlined
                  :clearable="true"
                  :prepend-icon="scanIcon"
              ></CommonFieldString>
              <v-radio-group
                  v-model="processData.supply_type"
                  row
              >
                <v-radio
                    v-for="supply_type in supply_type_list" :key="supply_type" filter
                    :label="supply_type"
                    :value="supply_type"
                    :color="supplyColor(supply_type)"
                ></v-radio>
              </v-radio-group>
              <v-select
                  v-if="processData.supply_type === 'Bulk'"
                  v-model="processData.package"
                  :items="packages"
                  dense
                  label="Package"
                  outlined
              >
              </v-select>
              <v-card-actions>
                <v-btn
                    ref="btn_next_material_registration"
                    @click="onMaterialRegistration()"
                    :disabled="!processData.material_qty || !processData.amount_packages || !processData.supply_type ||
                              (processData.supply_type === 'Bulk' && processData.package === null)"
                >{{ $t('next_step') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
          <template v-slot:item.6="{item}">
          </template>
          <template v-slot:item.7="{item}">
            <v-card>
              <!--              :rules="[() => processData.material_id_scan === processData.material_id_code]"-->
              <CommonFieldString
                  ref="field_material_id_scan"
                  v-model="processData.material_id_scan"
                  :color="processData.material_id_scan !== processData.material_id_code ? 'red': null"
                  :label="$t('material_id_code')"
                  :enter-input="stepChoiceVerificationSecond"
                  outlined
                  :clearable="true"
                  class="mt-1"
                  :prepend-icon="scanIcon"
              ></CommonFieldString>
              <!--              :rules="[() => processData.verification_scan === processData.verification_code]"-->
              <CommonFieldString
                  ref="field_verification_second"
                  v-model="processData.verification_scan"
                  :color="processData.verification_scan !== processData.verification_code ? 'red': null"
                  :label="$t('verification_code')"
                  :enter-input="onVerification"
                  outlined
                  :clearable="true"
                  :prepend-icon="scanIcon"
              ></CommonFieldString>
              <v-card-actions>
                <v-btn
                    :disabled="processData.material_id_scan !== processData.material_id_code || processData.verification_scan !== processData.verification_code"
                    @click="onVerification()"
                >{{ $t('next_step') }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn @click="rePrint()">{{ $t('re_print') }}</v-btn>
              </v-card-actions>
            </v-card>
          </template>
          <template v-slot:item.8="{item}"></template>
          <template v-slot:text.2="{item}">
            <v-chip v-if="!!materialTitle" label>{{ materialTitle }}</v-chip>
          </template>
          <template v-slot:text.3="{item}">
            <v-chip v-if="!!processData.actual_manufacture_mpn" label class="mr-3">{{
                processData.actual_manufacture_mpn
              }}
            </v-chip>
          </template>
          <template v-slot:text.4="{item}">
            <v-chip v-if="!!processData.part_number" label>{{ processData.part_number }}</v-chip>
          </template>
          <template v-slot:text.5="{item}">
            <v-chip
                v-if="!!processData.supply_type"
                label
                class="mr-1"
                :color="processData.supply_type !== processData.component_supply_type ? 'red accent-1': 'green accent-1'"
            >{{ processData.supply_type }}
            </v-chip>
            <v-chip v-if="!!processData.material_qty" label class="mr-1">{{ processData.material_qty }}</v-chip>
            <v-chip v-if="processData.mass_registration === true" label>{{ $t('mass_registration') }}
              ({{ processData.amount_packages }})
            </v-chip>
          </template>
          <template v-slot:footer>
            <v-row no-gutters>
              <v-btn :disabled="!processData.material_delivery_uid" @click="onFinishRegistration()" small>
                {{ $t('finish_registration') }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn :disabled="!processData.material_delivery_uid" @click="onMaterialDeliverySelect(null)" small>
                {{ $t('reset_registration') }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn :disabled="!processData.mass_registration" @click="onBreakMassRegistration()" small>
                {{ $t('break_mass_registration') }}
              </v-btn>
            </v-row>
          </template>
        </CommonStepper>
      </v-col>
      <v-col>
        <MaterialTable
            :title="materialTitle"
            dtoListQuery="MaterialBriefListQueryDTO"
            :store-name="storeMaterialTableName"
            :height="componentHeight - 130"
        >
        </MaterialTable>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import VueQrcode from 'vue-qrcode'
import MaterialDeliveryCardList from "@/components/CoreMaterial/MaterialDelivery/MaterialDeliveryCardList";
import {useDetailStore} from "@/components/Common/CommonDetail";
import {useAggregateStore} from "@/store/CommonStore/baseAggregateStore";
import {useCardListStore} from "@/components/Common/CommonCardList";
import {defineStore} from "pinia";
import MaterialDetail from "@/components/CoreMaterial/Material/MaterialDetail";
import MaterialDeliveryDetail from "@/components/CoreMaterial/MaterialDelivery/MaterialDeliveryDetail";
import BaseFieldSelect from "@/components/Base/BaseFieldSelect";
import CommonBtnAction from "@/components/Common/CommonBtnAction";
import CommonStepper, {useStepperStore} from "@/components/Common/CommonStepper";
import BaseFieldString from "@/components/Base/BaseFieldString";
import CommonPartialSelectFromTable from "@/components/Common/CommonPartialSelectFromTable";
import CommonSelectFromTable from "@/components/Common/CommonSelectFromTable";
import CommonTable from "@/components/Common/CommonTable";
import MaterialTable from "@/components/CoreMaterial/Material/MaterialTable";
import {useTableStore} from "@/components/Common/CommonTable";
import {useActionStore} from "@/components/Common/CommonBtnActionGroup";
import {mixinScanner} from "@/components/Common/MixinScanner"
import {useConfirmStore} from "@/components/Common/CommonConfirmDialog";
import CommonFieldString from "@/components/Common/CommonFieldString";
// import {useScannerStore} from "@/store/CommonStore/scannerStore";


export const useMaterialStepperStore = function (storeName) {
  return defineStore(storeName, {
        state: () => ({
          materialDeliveryUid: uuidv4(),
        }),
        getters: {},
        actions: {},
      }
  )
}

export default {
  name: "MaterialStepperQR",
  mixins: [mixinScanner],

  props: {
    storeName: {default: 'MaterialStepperQR'},
    selectedDeliveryUid: {default: null},
  },

  components: {
    VueQrcode,
    MaterialTable,
    CommonTable,
    CommonStepper,
    MaterialDeliveryDetail,
    MaterialDeliveryCardList,
    MaterialDetail,
    BaseFieldSelect,
    CommonBtnAction,
    BaseFieldString,
    CommonPartialSelectFromTable,
    CommonSelectFromTable,
    CommonFieldString,
  },
  computed: {
    componentHeight() {
      if (this.$vuetify.breakpoint.mobile)
        return this.$vuetify.breakpoint.height - 15 - 64
      return this.$vuetify.breakpoint.height - 15
    },
    materialTitle() {
      let result = null
      if (!!this.storeAggregate && !!this.processData.material_delivery_uid && !!this.storeAggregate.rootData[this.processData.material_delivery_uid]) {
        let delivery_number = this.storeAggregate.rootData[this.processData.material_delivery_uid].delivery_number
        let provider_uid = this.storeAggregate.rootData[this.processData.material_delivery_uid].provider_uid
        if (!!provider_uid)
          result = this.storeAggregate.rootData[provider_uid].name + ' : ' + delivery_number
      }
      return result
    },
    currentStep() {
      if (!!this.storeStepper)
        return this.storeStepper.currentStep
      else
        return null
    },
    providerUid() {
      if (!!this.processData.material_delivery_uid && !!this.storeAggregate.rootData[this.processData.material_delivery_uid])
        return this.storeAggregate.rootData[this.processData.material_delivery_uid].provider_uid
      else
        return null
    },
  },

  watch: {
    manual_component_uid: {
      handler(newValue, oldValue) {
        // console.log('watch select queryParameters', newValue, oldValue)
        if (!!newValue)
          this.processData.manual_manufacture_mpn = this.storeAggregate.rootData[newValue].alias
        else
          this.processData.manual_manufacture_mpn = null
      },
      deep: true
    },
    providerUid: {
      handler(newValue, oldValue) {
        // console.log('watch providerUid', newValue, oldValue)
        if (newValue !== oldValue)
          this.filterPartNumber()
      },
      deep: true
    },
    manual_part_number_uid: {
      handler(newValue, oldValue) {
        // console.log('watch select queryParameters', newValue, oldValue)
        if (!!newValue)
          this.processData.manual_part_number = this.storeAggregate.rootData[newValue].part_number
        else
          this.processData.manual_part_number = null
      },
      deep: true
    },
    currentStep: {
      handler(newValue, oldValue) {
        // console.log('watch currentStep', newValue, oldValue)
        if (newValue === 2 && !!this.selectedDeliveryUid) {
          this.onMaterialDeliverySelect(this.selectedDeliveryUid)
        }
        if (newValue === 3) {
          this.processData.provider_name = null
        }
      },
      deep: true
    },
  },

  methods: {
    filterPartNumber() {
      // console.log('filterPartNumber', this.providerUid)
      this.storePartNumberTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'provider__uid', value: this.providerUid,},
          {param_compare: 'deleted', value: false,},
        ],
        enable: true,
      }
    },
    finishScan(scan) {
      // console.log('finishScan', scan)
      for (let action of this.storeConfirmStore.action_list) {
        if (action.uid === scan && !!this[action.action]) {
          this.storeConfirmStore.dialog = false
          this[action.action]()
          return
        }
      }
      const parentComponent = this.findParentComponentEnter(document.activeElement)
      if (parentComponent) {
        // console.log('parentComponent', parentComponent)
        parentComponent.$emit('input', scan)
        parentComponent.$options.propsData.enterInput()
      }
    },
    embeddedCorrect() {
      // console.log('embeddedCorrect')
      this.focusToVerificationCode()
    },
    embeddedManualMPN() {
      // console.log('embeddedManualMPN', this.$refs)
      this.focusToManufactureMPN()
    },
    embeddedPreCreateMPN(input_list) {
      // console.log('embeddedPreCreateMPN', this.$refs, this.$refs, input_list)
      this.storeStepper.stepAction('pre_create_mpn', uuidv4(), this.processData,
          this.onReceiveVerificationCode)
    },
    embeddedCreateMPN(input_list) {
      // console.log('embeddedCreateMPN', this.$refs, input_list)
      this.processData.created_part_number = input_list.filter(row => row.name === 'part_number')[0].value
      this.processData.created_msl = input_list.filter(row => row.name === 'msl')[0].value
      this.storeStepper.stepAction('create_mpn', uuidv4(), this.processData,
          this.onReceiveVerificationCode)
    },
    embeddedCancelCreateMPN() {
      // console.log('embeddedCancelCreateMPN')
    },
    embeddedCorrectPN() {
      // console.log('embeddedCorrectPN')
      this.focusToPartNumberScan()
    },
    embeddedManualPN() {
      // console.log('embeddedManualPN')
      this.focusToPartNumber()
    },
    embeddedCreatePN(input_list) {
      // console.log('embeddedCreatePN')
      this.storeStepper.stepAction('create_pn', uuidv4(), this.processData,
          this.onReceivePartNumberCode)
    },
    embeddedMaterialIdScan() {
      // console.log('embeddedMaterialIdScan')
      this.focusToMaterialIdScan()
    },
    embeddedVerificationSecondCode() {
      // console.log('embeddedVerificationSecondCode')
      this.focusToVerificationSecond()
    },

    embeddedCancel() {
      // console.log('embeddedCancel')
    },

    focusToVerificationCode() {
      this.resetProcessData()
      this.$nextTick(() => {
        this.$refs.field_verification_code.$refs.v_text_field.focus()
      })
    },
    focusToManufactureMPN() {
      this.$nextTick(() => {
        this.$refs.field_manufacture_mpn.$refs.autocomplite.$refs.input.focus()
      })
    },
    focusToCreatedPN() {
      this.$nextTick(() => {
        if (this.processData.mandatory_pn)
          this.$refs.field_created_part_number.$refs.v_text_field.focus()
        else
          this.$refs.field_confirmation_mpn_creation.focus()
      })
    },
    focusToMaterialQty() {
      this.$nextTick(() => {
        this.$refs.field_material_qty.$refs.v_text_field.focus()
      })
    },
    focusToPartNumberScan() {
      // console.log('focusToPartNumberScan')
      this.processData.part_number_code = null
      this.processData.manual_part_number = null
      this.manual_part_number_uid = null
      this.$nextTick(() => {
        this.$refs.field_customer_part_number_scan.$refs.v_text_field.focus()
      })
    },
    focusToPartNumber() {
      // console.log('focusToPartNumber')
      this.$nextTick(() => {
        this.$refs.field_customer_part_number.$refs.input.focus()
      })
    },
    focusToMaterialIdScan() {
      this.$nextTick(() => {
        this.$refs.field_material_id_scan.$refs.v_text_field.focus()
      })
    },
    focusToVerificationSecond() {
      this.$nextTick(() => {
        this.$refs.field_verification_second.$refs.v_text_field.focus()
      })
    },

    supplyColor(supply_type) {
      if (supply_type !== this.processData.supply_type)
        return null
      if (this.processData.supply_type !== this.processData.component_supply_type)
        return 'red'
      else
        return 'green'
    },
    onCreateMaterialDelivery() {
      this.storeDetail.uidItem = uuidv4()
      this.storeAggregate.rootData[this.storeDetail.uidItem] = {
        uid: this.storeDetail.uidItem,
        class_name: 'MaterialDeliveryDTO',
        provider_uid: this.processData.provider_uid,
        material_owner_uid: this.processData.material_owner_uid,
        usage_restriction: this.processData.usage_restriction,
        mandatory_pn: this.processData.mandatory_pn,
        delivery_number: this.processData.delivery_number,
      }
      this.storeAggregate.uid_dict[this.storeDetail.uidItem] = {
        uid: this.storeDetail.uidItem,
        class_name: 'MaterialDeliveryDTO',
        provider_uid: this.processData.provider_uid,
        material_owner_uid: this.processData.material_owner_uid,
        usage_restriction: this.processData.usage_restriction,
        mandatory_pn: this.processData.mandatory_pn,
        delivery_number: this.processData.delivery_number,
      }
      this.storeDetail.create()
      this.processData.material_delivery_uid = this.storeDetail.uidItem
      this.storeMaterialDeliveryCardList.update()
      this.resetProcessData()
      this.storeStepper.currentStep = this.STEP_VERIFICATION_SCAN
      this.focusToVerificationCode()
      this.MakeMaterialFilters()
    },

    selectedMaterialDelivery(uid) {
      return this.processData.material_delivery_uid === uid
    },

    onMaterialDeliverySelect(event) {
      // console.log('onMaterialDeliverySelect', event)
      if (!!event) {
        this.processData.material_delivery_uid = event
        if (!!this.storeAggregate.rootData[event]) {
          this.processData.mandatory_pn = this.storeAggregate.rootData[event].mandatory_pn
          // console.log('this.processData.mandatory_pn', this.processData.mandatory_pn)
        }
      }
      this.storeDetail.uidItem = this.state.materialDeliveryUid
      this.resetProcessData()
      this.storeStepper.currentStep = this.STEP_VERIFICATION_SCAN
      this.focusToVerificationCode()
      this.MakeMaterialFilters()
    },

    resetProcessData() {
      this.processData.manual_manufacture_mpn = null
      this.processData.part_number_code = null
      this.processData.provider_name = null
      this.processData.manual_part_number = null
      this.manual_part_number_uid = null
      this.processData.created_part_number = null
      this.processData.created_msl = '1'
      this.processData.confirmation_mpn_creation = false
    },

    setLoad(step) {
      for (let item of this.storeStepper.stepList)
        if (item.step === step)
          item.load = true
    },

    onVerificationCode() {
      // console.log('onVerificationCode')
      if (!this.processData.verification_code)
        return
      this.$nextTick(() => {
        this.setLoad(this.STEP_VERIFICATION_SCAN)
        this.storeStepper.stepAction('check_verification_code', uuidv4(), this.processData,
            this.onReceiveVerificationCode)
      })
    },

    onReceiveVerificationCode(data) {
      // console.log('onReceiveVerificationCode', data)
      this.processData = data.action_state.action_results.data
      this.storeStepper.currentStep = data.action_state.action_results.current_step
      this.storeStepper.stepList = structuredClone(data.action_state.action_results.step_list)
      if (this.storeStepper.currentStep === this.STEP_SCAN_PN)
        this.focusToPartNumberScan()
      if (this.storeStepper.currentStep === this.STEP_MATERIAL_REGISTRATOR)
        this.focusToMaterialQty()
      this.launchStep(data)
    },

    onMaterialQty() {
      if (!this.processData.material_qty)
        return
      this.$nextTick(() => {
        // console.log('onMaterialQty', this.processData.material_qty)
        // this.processData.material_qty = parseInt(this.processData.material_qty)
        this.$refs['btn_next_material_registration'].$el.focus()
      })
    },

    onReceivePartNumberCode(data) {
      // console.log('onReceivePartNumberCode', data)
      this.processData = data.action_state.action_results.data
      this.storeStepper.currentStep = data.action_state.action_results.current_step
      this.storeStepper.stepList = structuredClone(data.action_state.action_results.step_list)
      if (this.processData.mass_registration === true) {
        this.storeStepper.stepAction('print_label', uuidv4(), this.processData, this.onReceivePrintLabel)
      } else if (data.action_state.action_results.focus_to_next)
        this.focusToMaterialQty()
      this.launchStep(data)
    },

    onPartNumber() {
      if (!this.processData.part_number_code && !this.processData.manual_part_number)
        return
      this.$nextTick(() => {
        this.setLoad(this.STEP_SCAN_PN)
        this.storeStepper.stepAction('check_part_number_code', uuidv4(), this.processData, this.onReceivePartNumberCode)
      })
    },

    onMaterialRegistration() {
      this.setLoad(this.STEP_MATERIAL_REGISTRATOR)
      this.storeStepper.stepAction('material_registration', uuidv4(), this.processData,
          this.onReceiveMaterialRegistration)
    },

    onReceiveMaterialRegistration(data) {
      // console.log('onReceiveMaterialRegistration', data)
      this.processData = data.action_state.action_results.data
      this.storeStepper.currentStep = data.action_state.action_results.current_step
      this.storeStepper.stepList = structuredClone(data.action_state.action_results.step_list)
      if (data.action_state.action_results.focus_to_next === false)
        this.$refs['btn_next_material_registration'].$el.focus()
      else
        this.onPrintLabel()
      this.launchStep(data)
    },

    onPrintLabel() {
      // console.log('onPrintLabel')
      this.setLoad(this.STEP_PRINT_LABEL)
      this.storeStepper.stepAction('print_label', uuidv4(), this.processData,
          this.onReceivePrintLabel)
    },

    rePrint() {
      // console.log('rePrint')
      this.storeStepper.stepAction('re_print', uuidv4(), this.processData,
          this.onReceivePrintLabel)
    },

    onReceivePrintLabel(data) {
      // console.log('onReceivePrintLabel', data)
      this.processData = data.action_state.action_results.data
      this.storeStepper.currentStep = data.action_state.action_results.current_step
      this.storeStepper.stepList = structuredClone(data.action_state.action_results.step_list)
      // if (data.action_state.action_results.focus_to_next === true)
      this.focusToMaterialIdScan()
      this.launchStep(data)
    },

    stepChoiceVerificationSecond() {
      if (!!this.processData.material_id_scan)
        this.focusToVerificationSecond()
    },

    onVerification() {
      this.$nextTick(() => {
        this.setLoad(this.STEP_VERIFICATION)
        this.storeStepper.stepAction('check_verification', uuidv4(), this.processData,
            this.onReceiveVerification)
      })
    },

    onReceiveVerification(data) {
      // console.log('onReceiveVerification', data)
      this.processData = data.action_state.action_results.data
      this.storeStepper.currentStep = data.action_state.action_results.current_step
      this.storeStepper.stepList = structuredClone(data.action_state.action_results.step_list)
      if (data.action_state.action_results.focus_to_next === true)
        this.onCreateMaterial()
      this.launchStep(data)
    },

    onCreateMaterial() {
      // console.log('onCreateMaterial')
      this.setLoad(this.STEP_CREATE_MATERIAL)
      this.storeStepper.stepAction('create_material', uuidv4(), this.processData,
          this.onReceiveCreateMaterial)
    },

    onReceiveCreateMaterial(data) {
      // console.log('onReceiveCreateMaterial', data)
      this.processData = data.action_state.action_results.data
      this.storeStepper.currentStep = data.action_state.action_results.current_step
      this.storeStepper.stepList = structuredClone(data.action_state.action_results.step_list)
      this.launchStep(data)
      this.focusToVerificationCode()
    },

    onFinishRegistration() {
      // this.setLoad(this.STEP_FINISH_REGISTRATION)
      this.storeStepper.stepAction('finish_registration', uuidv4(), this.processData,
          this.onReceiveFinishRegistration)
    },

    onReceiveFinishRegistration(data) {
      // console.log('onReceiveFinishRegistration', data)
      this.processData = data.action_state.action_results.data
      this.storeStepper.currentStep = data.action_state.action_results.current_step
      this.storeStepper.stepList = structuredClone(data.action_state.action_results.step_list)
      this.processData.material_delivery_uid = null
      this.storeDetail.uidItem = null
      this.storeDetail.provider_name = null
      this.launchStep(data)
    },

    onBreakMassRegistration(data) {
      this.storeStepper.currentStep = this.STEP_VERIFICATION_SCAN
      data.action_state.action_results.current_step = this.STEP_VERIFICATION_SCAN
      this.$refs["field_verification_mpn"].$refs.input.focus()
    },

    launchStep(data) {
      // console.log('launchStep', data)
      if (data.action_state.action_results.data.launch == null)
        return
      let launchFunction = this.launchStepDict[data.action_state.action_results.data.launch - 1]
      if (!!launchFunction) {
        launchFunction()
      }
    },

    MakeMaterialFilters() {
      this.storeMaterialTable.filters = this.storeMaterialTable.filters.filter(x => x.param_compare !== 'material_delivery__uid')
      this.storeMaterialTable.filters.push({
        param_compare: 'material_delivery__uid',
        value: this.processData.material_delivery_uid
      })
      this.storeMaterialTable.filters.push({param_compare: 'material_delivery__isnull', value: false})
    },
    testAction() {
      console.log('testAction')
    },
  }
  ,

  setup({storeName}) {
    let state = useMaterialStepperStore(storeName)()
    state.materialDeliveryUid = uuidv4()
    return {state}
  }
  ,

  mounted() {
    this.storeAggregate = useAggregateStore()
    this.storeStepper = useStepperStore(this.storeStepperName)()
    this.storeDetail = useDetailStore('MaterialDeliveryDetail')()
    this.storeDetail.uidItem = this.state.materialDeliveryUid
    this.storeDetail.dtoDetailQuery = 'MaterialDeliveryDetailQueryDTO'
    this.storeDetail.update()
    this.storeMaterialDeliveryCardList = useCardListStore('MaterialDeliveryCardListStepper')()
    this.storeMaterialTable = useTableStore(this.storeMaterialTableName)()
    this.MakeMaterialFilters()
    this.storeMaterialTable.headers = [
      {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'Article', value: 'component__article_display', sortable: true, filterable: true, divider: true},
      {text: 'Alias', value: 'component__alias', sortable: true, filterable: true, divider: true},
      {text: 'P/N', value: 'part_number__part_number', sortable: true, filterable: true, divider: true},
      // {text: 'Material owner', value: 'material_owner__name', sortable: true, filterable: true, divider: true},
      // {text: 'Usage restriction', value: 'usage_restriction__name', sortable: true, filterable: true, divider: true},
      // {text: 'Location', value: 'location_uid', sortable: true, filterable: true, divider: true},
      {text: 'Initial QTY', value: 'initial_qty', sortable: true, filterable: true, divider: true},
      // {text: 'Current QTY', value: 'current_qty', sortable: true, filterable: true, divider: true},
      {
        text: 'Reservation quantity',
        value: 'reservation_quantity',
        sortable: true,
        filterable: true,
        divider: true,
        width: 40
      },
      {text: 'Supply type', value: 'supply_type', sortable: false, filterable: true, divider: true, width: 100},
      {text: 'Package', value: 'package', sortable: false, filterable: true, divider: true, width: 40},
      // {text: 'State', value: 'state', sortable: true, filterable: true, divider: true, width: 100},
      // {text: 'Parent', value: 'parent_uid', sortable: true, filterable: true, divider: true},
      // {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      // {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'Location', value: 'location__name', sortable: true, filterable: true, divider: true, width: 100},
      {
        text: 'Parent location',
        value: 'location__parent__name',
        sortable: true,
        filterable: true,
        divider: true,
        width: 100
      },
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeConfirmStore = useConfirmStore('CommonConfirmDialog')()
    this.storeConfirmStore.actionBtn = [
      {uid: uuidv4(), label: 'Test1', text: 'Action description', action: this.testAction},
      {uid: uuidv4(), label: 'Cancel', text: 'Action cancel', action: this.testAction},
    ]
    this.storeConfirmStore.timeout = -1

    this.storePartNumberTable = useTableStore(this.storePartNumberTableName)()
    this.filterPartNumber()
  }
  ,

  data() {
    return {
      packages: [
        'Bag',
        'Stick',
        'Plastic box',
        'Cardboard box',
        'Plastic Tray',
        'Styrofoam Tray',
        'Reel'
      ],
      manualIcon: "mdi-square-edit-outline",
      scanIcon: "mdi-qrcode-scan",
      storeStepperName: 'MaterialDeliveryStepper',
      storeSelectProviderName: 'SelectProvider',
      storeMaterialTableName: 'MaterialTableStepper',

      manual_component_uid: null,
      manual_part_number_uid: null,
      create_part_number: false,

      processData: {
        material_delivery_uid: this.selectedDeliveryUid,
        delivery_number: null,
        provider_uid: null,
        provider_name: null,
        material_owner_uid: null,
        usage_restriction_uid: null,
        manufacture_mpn: null,
        manual_manufacture_mpn: null,
        mandatory_pn: true,
        created_part_number: null,
        created_msl: '1',
        confirmation_mpn_creation: false,
        part_number_code: null,
        part_number: null,
        manual_part_number: null,
        amount_packages: 1,
        material_qty: null,
        material_id_code: null,
        material_id_scan: null,
        verification_code: null,
        verification_scan: null,

        supply_type: null,
        package: null,
        component_supply_type: null,
        mass_registration: false,
        launch: null,
        focus_to_next: true,
      },
      supply_type_list: ['Tape and reel', 'Tray', 'Stick', 'Bulk'],
      providerNameList: ['mouser'],

      storeAggregate: null,
      storeStepper: null,
      storeDetail: null,
      storeMaterialTable: null,
      storeMaterialDeliveryCardList: null,
      storeConfirmStore: null,

      storePartNumberTable: null,
      storePartNumberTableName: uuidv4(),

      queryPartNumberFilters: null,

      STEP_CREATE_MATERIAL_DELIVERY: 1,
      STEP_CHOICE_MATERIAL_DELIVERY: 2,
      STEP_VERIFICATION_SCAN: 3,
      STEP_SCAN_PN: 4,
      STEP_MATERIAL_REGISTRATOR: 5,
      STEP_PRINT_LABEL: 6,
      STEP_VERIFICATION: 7,
      STEP_CREATE_MATERIAL: 8,
      STEP_FINISH_REGISTRATION: 9,

      launchStepDict: [
        null,
        null,
        this.onVerificationCode,
        this.onPartNumber,
        this.onMaterialRegistration,
        this.onPrintLabel,
        this.onVerification,
        this.onCreateMaterial,
        // this.onFinishRegistration
      ],
    }
  }
  ,
}
</script>


<style scoped>

</style>


<i18n src="@/components/CoreMaterial/locales.json">
</i18n>